import { defaultClient } from '@api/client';

export const updateProfilePicture = ({ id, profileImage }) => {
  let formData = new FormData();
  formData.append('profileImage', profileImage);

  return defaultClient.post(`/users/${id || 'self'}/profileImage`, formData);
};
